module.exports = __webpack_public_path__ + "img/consultation.dce3ec56.png";